import { Box, Skeleton } from '@mui/material';
import React from 'react';

import { borderRadius, dashboardCardDimensions } from '../../../assets/styles/themes/tokens';

interface CardSkeletonProps {
	height?: number;
	width?: number;
	radius?: string;
}

const CardSkeleton: React.FC<CardSkeletonProps> = ({
	height = dashboardCardDimensions.height,
	width = dashboardCardDimensions.width,
	radius = borderRadius.lg,
}) => {
	return (
		<Box
			sx={{
				display: 'flex',
				justifyContent: 'flex-start',
				alignItems: 'flex-start',
			}}
		>
			<Skeleton sx={{ borderRadius: radius }} variant="rectangular" width={width} height={height} />
		</Box>
	);
};

export default CardSkeleton;
